import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type GPTModel = 'gpt-5.4' | 'gpt-5.4-mini' | 'gpt-5.4-nano' | 'gpt-4.1'

interface SettingsState {
  aiEnabled: boolean
  gptModel: GPTModel
  
  // Actions
  setAIEnabled: (enabled: boolean) => void
  setGPTModel: (model: GPTModel) => void
  clearSettings: () => void
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      aiEnabled: true,
      gptModel: 'gpt-5.4-mini',

      setAIEnabled: (enabled) => 
        set({ aiEnabled: enabled }),

      setGPTModel: (model) => 
        set({ gptModel: model }),

      clearSettings: () => 
        set({ 
          aiEnabled: true,
          gptModel: 'gpt-5.4-mini'
        }),
    }),
    {
      name: 'kook-inspiratie-settings'
    }
  )
)
